if (!window.lolaBlogStats) {
  window.lolaBlogStats = fetch('https://clipstrip.github.io/clipstrip-blog-stats/lola-blog-stats.json', {credentials:'omit',signal:AbortSignal.timeout(10000)}).then(r => {
    if(!r.ok) throw Error('Statistics unavailable');
    return r.json();
  }).then(data => {
    if(data.propertyId!=='384021303' || !data.allTimeCounts || !data.recentCounts || !Array.isArray(data.mostViewed)) throw Error('Invalid statistics');
    return data;
  }).catch(() => null);
}
window.lolaBlogStats.then(stats => {
  if(!stats)return;
  const canonical = path => path.replace(/\/$/,'')+'/';
  const count = path => stats.allTimeCounts[canonical(path)] || 0;
  document.querySelectorAll('[data-lola-article-views]').forEach(node => {
    node.textContent=count(node.dataset.lolaArticleViews).toLocaleString()+' '+(node.dataset.viewsLabel||'views');
    node.hidden=false;
  });
  document.querySelectorAll('.lola-sw-mv').forEach(list => {
    if(list.dataset.statsUpdated===stats.generatedAt)return;
    const fragment=document.createDocumentFragment();
    stats.mostViewed.slice(0,5).forEach(p => {
      if(!/^\/blogs\/news\/[^/?#]+\/?$/.test(p.url)||!Number.isFinite(p.views))return;
      const li=document.createElement('li'),body=document.createElement('div'),link=document.createElement('a'),views=document.createElement('span');
      body.className='lola-sw-mv-body';link.href=p.url;link.textContent=p.title;views.className='lola-sw-mv-count';views.textContent=p.views.toLocaleString()+' '+(list.dataset.viewsLabel||'views');
      body.append(link,views);li.append(body);fragment.append(li);
    });
    if(fragment.childNodes.length){list.replaceChildren(fragment);list.dataset.statsUpdated=stats.generatedAt;}
  });
});

(() => {
  document.querySelectorAll('[data-lola-rankings]').forEach(root => {
    if (root.dataset.rankingReady) return;
    root.dataset.rankingReady = 'true';
    const labels = JSON.parse(root.querySelector('[data-lola-rank-labels]').textContent);
    const tags = JSON.parse(root.dataset.tags || 'null') || [];
    const latest = root.querySelector('[data-lola-latest]');
    const ranked = root.querySelector('[data-lola-ranked]');
    const grid = root.querySelector('[data-lola-ranked-grid]');
    const status = root.querySelector('.lola-rank-status');
    const pager = root.querySelector('.lola-rank-pages');
    const previous = root.querySelector('[data-rank-prev]');
    const next = root.querySelector('[data-rank-next]');
    const buttons = [...root.querySelectorAll('[data-sort]')];
    let mode = 'latest', page = 1, data, loading;
    const normalize = value => value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const element = (tag, cls, text) => {
      const node = document.createElement(tag);
      if (cls) node.className = cls;
      if (text !== undefined) node.textContent = text;
      return node;
    };
    const rows = () => data.articles.filter(a => a[mode] > 0 && tags.every(tag => a.tags.some(t => normalize(t) === normalize(tag)))).sort((a,b) => b[mode]-a[mode] || a.url.localeCompare(b.url));
    const dateLabel = value => new Date(value+'T12:00:00Z').toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric',timeZone:'UTC'});
    function render() {
      const list = rows(), pages = Math.max(1, Math.ceil(list.length / 12));
      page = Math.min(page, pages);
      grid.replaceChildren();
      status.textContent = (mode === 'recent' ? labels.recent + ': ' + dateLabel(data.recentStart) + ' – ' + dateLabel(data.recentEnd) : labels.all + ': ' + dateLabel(data.allStart) + ' – ' + dateLabel(data.updated)) + '. ' + labels.updated + ' ' + dateLabel(data.updated) + '.';
      if (!list.length) grid.append(element('p','lola-empty',labels.empty));
      list.slice((page-1)*12,page*12).forEach(a => {
        const card=element('article','lola-card');
        const media=element('a','lola-card__media'); media.href=a.url; media.setAttribute('aria-label',a.title);
        if (a.image) {const img=element('img'); img.src=a.image+(a.image.includes('?')?'&':'?')+'width=750'; img.alt=a.alt; img.loading='lazy'; media.append(img);}
        const activeTag=[...root.querySelectorAll('.lola-catbar__list a')].find(link=>a.tags.some(t=>normalize(t)===link.pathname.split('/tagged/')[1]));
        if(activeTag) media.append(element('span','lola-chip',activeTag.textContent));
        const body=element('div','lola-card__body'); const title=element('h2','lola-card__title'); const link=element('a',null,a.title); link.href=a.url; title.append(link); body.append(title);
        if(a.summary){const doc=new DOMParser().parseFromString(a.summary,'text/html'); const words=(doc.body.textContent||'').trim().split(/\s+/); body.append(element('p','lola-card__excerpt',words.slice(0,20).join(' ')+(words.length>20?'…':'')));}
        body.append(element('div','lola-card__meta',a[mode].toLocaleString()+' '+labels.views)); card.append(media,body); grid.append(card);
      });
      previous.disabled=page===1; next.disabled=page===pages; pager.hidden=pages===1;
      root.querySelector('[data-rank-page]').textContent=labels.page+' '+page+' '+labels.of+' '+pages;
    }
    async function loadRankingData() {
      const snapshot = await fetch(root.dataset.lolaRankings).then(r=>{if(!r.ok)throw Error('Snapshot unavailable');return r.json();});
      const stats = await window.lolaBlogStats;
      if(!stats)return snapshot;
      let articles=snapshot.articles;
      try {
        let currentPage=1, pages=1, collected=[];
        do {
          const url=new URL('/blogs/news',location.origin);url.searchParams.set('view','rankings-data');url.searchParams.set('page',currentPage);
          const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
          const response=await fetch(url,{signal:AbortSignal.timeout(15000)});
          if(!response.ok)throw Error('Catalog unavailable');
          const result=await response.json();if(!Array.isArray(result.articles)||!Number.isInteger(result.pages)||result.pages<1||result.pages>100)throw Error('Invalid catalog');
          collected.push(...result.articles);pages=result.pages;currentPage++;
        } while(currentPage<=pages);
        if(collected.length)articles=collected;
      } catch(e) {}
      return {...snapshot,updated:stats.dataThrough,recentStart:stats.trendingRange.startDate,recentEnd:stats.trendingRange.endDate,allStart:stats.mostViewedRange.startDate,articles:articles.map(a=>{const key=a.url.replace(/\/$/,'')+'/';return {...a,all:stats.allTimeCounts[key]||0,recent:stats.recentCounts[key]||0};})};
    }
    async function select(value, update=true) {
      mode=value; page=1;
      buttons.forEach(b=>{const selected=b.dataset.sort===mode; b.classList.toggle('is-active',selected); b.setAttribute('aria-pressed',String(selected));});
      root.querySelectorAll('.lola-catbar__list a').forEach(a=>{const url=new URL(a.href); if(mode==='latest')url.searchParams.delete('sort');else url.searchParams.set('sort',mode);a.href=url.href;});
      if(update){const url=new URL(location.href); if(mode==='latest')url.searchParams.delete('sort');else url.searchParams.set('sort',mode); history.replaceState(null,'',url);}
      latest.hidden=mode!=='latest'; ranked.hidden=mode==='latest'; status.hidden=mode==='latest';
      if(mode==='latest')return;
      grid.replaceChildren(); pager.hidden=true; status.textContent=labels.loading;
      const requested=mode;
      try {
        if(!data){loading ||= loadRankingData().then(result=>{data=result;return result;}).catch(e=>{loading=null;throw e;});await loading;}
        if(mode===requested)render();
      }catch(e){if(mode===requested)status.textContent=labels.error;}
    }
    buttons.forEach(button=>button.addEventListener('click',()=>select(button.dataset.sort)));
    previous.addEventListener('click',()=>{page--;render();});
    next.addEventListener('click',()=>{page++;render();});
    const initial=new URL(location.href).searchParams.get('sort');
    if(['recent','all'].includes(initial))select(initial,false);
  });
})();
